export const OBSERVABILITY_NOISE_URL_PATTERNS = [
  /^https:\/\/api2\.amplitude\.com\//,
  /^https:\/\/api-sr\.amplitude\.com\//,
  /^https:\/\/sr-client-cfg\.amplitude\.com\//,
  /^https:\/\/metrics\.skedsocial\.com\//,
  /^https:\/\/px\.ads\.linkedin\.com\//,
  /^https:\/\/www\.google\.com\//,
  /^https:\/\/bat\.bing\.com\//,
  /^https:\/\/ct\.pinterest\.com\//,
  /^https:\/\/(?:[^/]+\.)+hubspot\.com\//,
  /^https:\/\/(?:[^/]+\.)+doubleclick\.net\//,
  /^https:\/\/tracking\.g2crowd\.com\//,
  /^https:\/\/content\.hotjar\.io\//,
  /^https:\/\/notify\.bugsnag\.com\//,
  /^https:\/\/sessions\.bugsnag\.com\//,
  /^https:\/\/oo(?:ingest|logs)\.skedsocial\.com\//,
];

const OBSERVABILITY_NOISE_TEXT_PATTERNS = [
  /ResizeObserver loop (?:completed with undelivered notifications|limit exceeded)\.?/i,
  /Amplitude Logger/i,
  /\[bugsnag\]\s+(?:Event|Session) failed to send/i,
  /notify\.bugsnag\.com/i,
  /sessions\.bugsnag\.com/i,
  /api2\.amplitude\.com/i,
  /api-sr\.amplitude\.com/i,
  /sr-client-cfg\.amplitude\.com/i,
  /metrics\.skedsocial\.com/i,
  /px\.ads\.linkedin\.com/i,
  /ct\.pinterest\.com/i,
  /s\.pinimg\.com/i,
  /Pinterest Tag Error: 'load' command was called multiple times/i,
  /content\.hotjar\.io/i,
  /oo(?:ingest|logs)\.skedsocial\.com/i,
];

export function isObservabilityNoiseUrl(url: string) {
  return OBSERVABILITY_NOISE_URL_PATTERNS.some((pattern) => pattern.test(url));
}

export function isObservabilityNoiseText(text: string) {
  return OBSERVABILITY_NOISE_TEXT_PATTERNS.some((pattern) =>
    pattern.test(text)
  );
}

export function isObservabilityNoise(
  ...parts: Array<string | null | undefined>
) {
  const combined = parts.filter(Boolean).join("\n");

  return combined.length > 0 && isObservabilityNoiseText(combined);
}
